import React from 'react'

import { Layout } from 'components'
import { ProjectsList } from 'modules/Projects/containers'
import { ProjectHeader } from 'modules/Projects/components'
import { FilterProjects } from 'modulesCommon/Filters/containers'
import { FeedbackModal } from 'modulesCommon/FeedbackModal/containers'

const ProjectsPage = () => (
  <Layout>
    <div className="sbx-row sbx-row-gutter-20">
      <div className="sbx-col-xs-24 sbx-col-xs-order-1 sbx-col-md-24 sbx-col-md-order-1 sbx-col-lg-24 sbx-col-lg-order-0">
        <ProjectHeader>
          <FilterProjects />
        </ProjectHeader>
        <ProjectsList />
      </div>
    </div>
    <FeedbackModal />
  </Layout>
)

export default ProjectsPage
